import React, { Component } from "react";
import PropTypes from "prop-types";
import CurriculumItem from "./CurriculumItem";
import iconMaths from "../../../../../public/img/icons/maths.svg";
import iconScience from "../../../../../public/img/icons/science.svg";
import iconTech from "../../../../../public/img/icons/tech.svg";
import iconEnglish from "../../../../../public/img/icons/english.svg";
import iconHass from "../../../../../public/img/icons/hass.svg";
import iconArt from "../../../../../public/img/icons/art.svg";

const icons = {
  1: iconScience,
  2: iconMaths,
  3: iconTech,
  4: iconScience,
  5: iconMaths,
  6: iconEnglish,
  7: iconArt,
  8: iconHass
};

export default class SubjectGroup extends Component {
  render() {
    return (
      <div
        id={`text-subject-heading-${this.props.subjectId}`}
        className={`subject-group tag-subject-${
          this.props.subjectId
        } col-12 col-lg-6 pb-3 w-100`}
      >
        <div className="subject-group-header d-flex justify-content-center align-items-center w-100 py-2 px-3">
          <h2 className="w-100 p-2">{this.props.subjectName}</h2>
          <img src={icons[this.props.subjectId]} height="30px" />
        </div>
        <ol>
          {this.props.items.map((e, i) => (
            <li key={i}>
              <CurriculumItem key={i} {...e} />
            </li>
          ))}
        </ol>
      </div>
    );
  }
}

SubjectGroup.propTypes = {
  items: PropTypes.array.isRequired,
  subjectName: PropTypes.string.isRequired,
  subjectId: PropTypes.number.isRequired
};



// WEBPACK FOOTER //
// ./resources/assets/js/app/CurriculumBlock/SubjectGroup.js